import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './introbox.module.scss';

const propTypes = {
  className: PropTypes.string
};

const IntroBox = ({className = '', ...rest}) => (
  <div className={cx(styles.introbox, className)} {...rest} />
);

IntroBox.propTypes = propTypes;

export default IntroBox;
